import React from "react";

const CopyLink = ({ ...rest }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            { ...rest }
        >
            <path
                d="M14.2514 19.7569L12.7499 21.2584C10.6768 23.3315 7.31552 23.3315 5.24237 21.2584C3.16921 19.1852 3.16921 15.824 5.24237 13.7508L6.74388 12.2493M20.2575 13.7508L21.759 12.2493C23.8321 10.1762 23.8321 6.81491 21.759 4.74175C19.6858 2.6686 16.3246 2.6686 14.2514 4.74176L12.7499 6.24327M9.78462 16.7161L17.2167 9.28399"
                stroke="#0F1016"
                strokeWidth="2.12042"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CopyLink;
